import { Injectable } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import {
  SignApplicationAgreementActionData,
  SignLoanAgreementActionData,
} from "../models/identity-verification-actions.model";
import { NavigationService } from "projects/my/src/app/core/navigation/navigation.service";
import {
  SessionStorageKey,
  SessionStorageState,
} from "common";

@UntilDestroy()
@Injectable({
  providedIn: "root",
})
export class IdentityNavigationService {
  constructor(private navigationService: NavigationService) {}

  signApplicationAgreement(data: SignApplicationAgreementActionData) {
    SessionStorageState.set(SessionStorageKey.ApplicationAgreementViewed, true);
    this.navigationService.navigateToPortal(`application/${data.applicationId}/setup/sign-agreement`);
  }

  signLoanAgreement(data: SignLoanAgreementActionData) {
    SessionStorageState.set(SessionStorageKey.AccountAgreementViewed, true);
    this.navigationService.navigateToPortal(`account/${data.loanId}/setup/sign-agreement`);
  }
}
